import { fetcher } from '@bino/utils/fetcher';
import { AddToCartRequest, Arrangement, RedirectToBiax, SignInRequest } from './types';

export async function signIn(bannerId?: string): Promise<void> {
    const url = new URL(window.location.href);
    if (bannerId) {
        url.searchParams.set('a', bannerId);
    }

    const signInRequest: SignInRequest = {
        currentUrl: url.toString(),
    };
    const result = await fetcher.post<RedirectToBiax>('/api/cart/signIn', signInRequest);

    if (result?.url) {
        window.location.href = result.url;
    }
}

export async function addToCart(arrangements: Arrangement[], isAuthorized?: boolean): Promise<void> {
    const body: AddToCartRequest = {
        arrangementBannerId: arrangements[0].bannerId,
    };

    if (isAuthorized) {
        return await fetcher.post('/api/cart', body);
    }

    return await signIn(arrangements[0].bannerId);
}

export async function deleteCartItem(bannerId: string): Promise<void> {
    await fetcher.delete(`/api/cart/item/${bannerId}`);
}
